export type ReportFormatType = 'client_report' | 'alimentation_report';

export interface ReportFormat {
  id?: string;
  report_type: ReportFormatType;
  header_text: string | null;
  header_image: string | null;    // base64 data URL
  footer_text: string | null;
  accent_color: string | null;    // hex e.g. "#1565c0"
  font_family: string | null;
  header_font_size: number | null;   // pt, e.g. 10
  header_text_color: string | null;  // hex e.g. "#555555"
  custom_intro: string | null;
  custom_closing: string | null;
}

export const REPORT_FORMAT_DEFAULTS: Record<ReportFormatType, Partial<ReportFormat>> = {
  client_report: {
    accent_color: '#1565c0',
    font_family: 'Arial',
  },
  alimentation_report: {
    accent_color: '#27ae60',
    font_family: 'Arial',
  },
};

// No hard size limit — image is stored as base64 in a PostgreSQL Text column.
// A soft warning fires above 3 MB since very large images slow print rendering.

export const FONT_OPTIONS = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: "'Segoe UI', sans-serif", label: 'Segoe UI' },
];

export const COLOR_PRESETS = [
  '#1565c0', // blue
  '#0d47a1', // dark blue
  '#1b5e20', // dark green
  '#27ae60', // green
  '#6a1b9a', // purple
  '#b71c1c', // red
  '#e65100', // orange
  '#37474f', // dark gray
  '#2c3e50', // charcoal
];
